module.exports = __webpack_public_path__ + "img/approve-list11.5.3ffd9c56.png";